module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if(locals.status === 'available' || locals.url) { 
    ; __append(" <button class=\"btn btn-sm btn-block btn-secondary download-report\"> <span class=\"d-none d-sm-inline-block\">Download</span> <span class=\"fa fa-download\"></span> </button> ")
    ;  } else if(locals.status === 'failed') { 
    ; __append(" <div class=\"text-danger text-center\">Failed</div> ")
    ;  } else if(locals.status === 'new') { 
    ; __append(" <div id=\"report_loader\" class=\"loader-sm\"></div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/reports/download_report.ejs
// module id = 1692
// module chunks = 1